import axios from 'lib/axios'
import { PercentileData, PercentileState } from '../store'
import { PERCENTILES_PATH } from '../constants'

export const fetchPercentiles = async (
  userId: number,
  testId: number,
  userTestId?: number
): Promise<PercentileData> => {
  const response: PercentileState = await axios.get(`${PERCENTILES_PATH}/${userId}?test_id=${testId}`, {
    params: { user_test_id: userTestId },
  })
  return response.data
}
